module.exports = __webpack_public_path__ + "img/game-innner2.fd179718.png";